import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "personify",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const pwaConfig = require("./PWAConfig").default;
          cb(null, pwaConfig);
        },
        "PWAConfig"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/PWAConfig/index.js